import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";

/**
 * Financial Fields
 * Billing, cost, and SLA fields.
 *
 * No `savedViewMembership` — these columns are not included in any default
 * saved view in `../saved-views/ticket-saved-views.ts`.
 */
export const financialFields = defineFieldConfigMap({
  // FIELD: hourly_rate
  hourly_rate: {
    type: "number",
    label: "Hourly Rate",
    placeholder: "Rate per hour",
    validation: {
      min: 0,
      max: 9999.99,
    },
    // Table properties
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: false,
    filterType: "numberRange",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Settings",
    // Internal billing rate — staff only.
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "financial",
    graphqlSelector: "hourly_rate",
  },

  // FIELD: total_cost
  total_cost: {
    type: "number",
    label: "Total Cost",
    placeholder: "Total cost calculated from time entries",
    validation: {
      min: 0,
      max: 999999.99,
    },
    // Table properties
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: false, // Auto-calculated from time entries
    filterType: "numberRange",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Settings",
    // Role-based access control - admin only
    allowedRoles: ["wtc_admin"],
    mobileDetailSectionId: "financial",
    graphqlSelector: "total_cost",
  },

  // FIELD: total_billed
  total_billed: {
    type: "number",
    label: "Total Billed",
    placeholder: "Total amount billed",
    validation: {
      min: 0,
      max: 999999.99,
    },
    // Table properties
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true, // Editable by admins
    filterType: "numberRange",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Settings",
    // Role-based access control - admin only
    allowedRoles: ["wtc_admin"],
    mobileDetailSectionId: "financial",
    graphqlSelector: "total_billed",
  },

  // FIELD: sla_hours
  sla_hours: {
    type: "number",
    label: "SLA Hours",
    placeholder: "Service level agreement hours",
    validation: {
      min: 0,
      max: 999,
    },
    // Table properties
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    filterType: "numberRange",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Settings",
    // Internal SLA config — staff only.
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "financial",
    graphqlSelector: "sla_hours",
  },

  // FIELD: escalation_level
  escalation_level: {
    type: "number",
    label: "Escalation Level",
    placeholder: "Escalation level",
    validation: {
      min: 0,
      max: 10,
    },
    // Table properties
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    filterType: "numberRange",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Settings",
    // Internal escalation state — staff only.
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "financial",
    graphqlSelector: "escalation_level",
  },
});
